const featuresData = [
  {
    icon: 'ri-flashlight-line',
    title: '极速同步',
    desc: '多源实时监控，热点事件爆发后 5 分钟内同步上线，确保你永远快人一步吃到最新鲜的瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '全面覆盖',
    desc: '横跨娱乐圈、网红圈、综艺圈、体育圈等 30+ 垂直领域，一个平台看尽天下八卦。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    desc: '累计收录超过 50,000 条爆料记录，支持按时间、热度、话题等多维度回溯历史大瓜。',
  },
  {
    icon: 'ri-eye-line',
    title: '纯净浏览',
    desc: '无弹窗广告干扰，无强制注册门槛，打开即看，给你最清爽的吃瓜体验。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续更新',
    desc: '每日 200+ 条动态滚动更新，运营团队 7×24 小时值守，节假日不休，精彩不间断。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            为什么千万吃瓜群众选择我们？五大核心优势给你答案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-6 text-center hover:bg-background-50 transition-colors duration-200 group cursor-default"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}